import { Todos } from './types';

export const intialStateTodos: Todos = [];
